import { FilterFilled } from '@ant-design/icons';
import { OrderListFilter } from '@restaurant/api';
import {
  ORDER_STATUS_OPTIONS,
  ORDER_TYPE_OPTIONS,
  PAYMENT_METHOD_OPTIONS,
} from '@restaurant/constants';
import { OrderStatus, PaymentMethod } from '@restaurant/types';
import { sanitizeParams } from '@restaurant/utils';
import { Button, Drawer, Form, Input, Select, TimePicker } from 'antd';
import dayjs from 'dayjs';
import React, { useState } from 'react';

const orderStatusOptions = ORDER_STATUS_OPTIONS.filter(
  ({ value }) => value !== OrderStatus.Open
);

const Filter = ({
  numberIcon,
  setValue,
}: {
  numberIcon: number;
  setValue: (values: OrderListFilter) => void;
}) => {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();

  const onReset = () => {
    form.resetFields();
    setValue({});
    setOpen(false);
  };

  const onFinish = (values: {
    orderNumber: string;
    dateTimeOrder?: dayjs.Dayjs[];
    dateTimePayment?: dayjs.Dayjs[];
    statuses: OrderStatus[];
    paymentMethods: PaymentMethod[];
    customerName?: string;
    tableNumber?: number;
  }) => {
    const { dateTimeOrder, dateTimePayment, orderNumber, ...rest } = values;
    setValue(
      sanitizeParams({
        ...(orderNumber ? { orderNumbers: [orderNumber] } : {}),
        ...(dateTimeOrder
          ? {
              startDateTimeOrder: dateTimeOrder[0].unix(),
              endDateTimeOrder: dateTimeOrder[1].unix(),
            }
          : {}),
        ...(dateTimePayment
          ? {
              startDateTimePayment: dateTimePayment[0].unix(),
              endDateTimePayment: dateTimePayment[1].unix(),
            }
          : {}),
        ...rest,
      })
    );
    setOpen(false);
  };

  return (
    <>
      <div
        className="flex items-center gap-1 cursor-pointer"
        onClick={() => setOpen(true)}
      >
        <FilterFilled />
        <p className="mb-0 text-lg mr-[2px]">Filter</p>
        {numberIcon ? (
          <div className="text-white bg-brand-red rounded-full w-5 h-5 font-bold flex justify-center items-center text-sm">
            {numberIcon}
          </div>
        ) : null}
      </div>
      <Drawer title="Filter" open={open} onClose={() => setOpen(false)}>
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item label="No. Order" name="orderNumber">
            <Input placeholder="No. Order" />
          </Form.Item>
          <Form.Item label="Waktu Pesan" name="dateTimeOrder">
            <TimePicker.RangePicker format="HH:mm" />
          </Form.Item>
          <Form.Item label="Waktu Bayar" name="dateTimePayment">
            <TimePicker.RangePicker format="HH:mm" />
          </Form.Item>
          <Form.Item label="Tipe Order" name="orderTypes">
            <Select
              options={ORDER_TYPE_OPTIONS}
              placeholder="Tipe Order"
              mode="multiple"
            />
          </Form.Item>
          <Form.Item label="Status" name="statuses">
            <Select
              options={orderStatusOptions}
              placeholder="Status"
              mode="multiple"
            />
          </Form.Item>
          <Form.Item label="Metode Bayar" name="paymentMethods">
            <Select
              options={PAYMENT_METHOD_OPTIONS}
              placeholder="Metode Bayar"
              mode="multiple"
            />
          </Form.Item>
          <Form.Item label="Nama Customer" name="customerName">
            <Input placeholder="Nama Customer" />
          </Form.Item>
          <Button htmlType="submit" type="primary" block>
            Submit
          </Button>
          <Button onClick={onReset} block className="mt-2">
            Reset
          </Button>
        </Form>
      </Drawer>
    </>
  );
};

export default Filter;
